@if (keycloakAuth.actif) {
    <div class="auth-keycloak" role="status">
        @if (etatKeycloak() === 'echec') {
            <div class="text-danger text-center" aria-live="polite">{{ messageEchec() }}</div>
        } @else {
            <mat-spinner />
        }
    </div>
} @else {
    <form [formGroup]="formLogin" class="auth" novalidate autocomplete="off" (ngSubmit)="connexion()">
        <mat-card class="carte-connexion">
            <div class="card-body">
                <div class="titreGalaclick text-center">
                    <img src="./assets/img/titre.png" alt="">
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input-gala #login formControlName="login" icone="fas fa-id-card prefix"
                            [placeholder]="lgTrad.LOGIN" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input-gala #pass formControlName="pass" icone="fas fa-lock prefix" type="password"
                            [placeholder]="lgTrad.PASSWORD" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mdpOubli" (click)="showModalOubli()">
                        {{lgTrad.MDPOUBLI}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-center mt-4">
                        <button mat-raised-button color="accent" class="gala-button-large">{{lgTrad.SIGNIN}}</button>
                    </div>
                </div>
            </div>
        </mat-card>
        <div class="bottom-absolute negative-z-index">
            <img class="width_45" src="./assets/img/banner-FEDER.png" alt="">
        </div>
    </form>
}